// SaleReturn Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get saleList from backend then update saleList in vuex store ***** //
export const updateSaleReturnList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('sale_return_index', { params: params })
    commit('updateSaleReturnList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Get saleList from backend then update saleList in vuex store ***** //
export const updateReportSaleReturnList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get(`report_sale_return/${payload.id}`, {
      params: params
    })
    commit('updateSaleReturnList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch SaleReturn from backend ***** //
export const fetchSaleReturnInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`sale_return_show/${payload}`)
    commit('fetchSaleReturnInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch unClosedSaleReturnCount from backend ***** //
export const fetchUnClosedSaleReturnCount = async ({ commit }) => {
  try {
    const result = await Axios.get(`unclosed_sale_return_count`)
    commit('fetchUnClosedSaleReturnCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch unClosedSaleReturnCount from backend ***** //
export const fetchUnPaidSaleReturnCount = async ({ commit }) => {
  try {
    const result = await Axios.get(`unpaid_sale_return_count`)
    commit('fetchUnPaidSaleReturnCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch unClosedReportSaleReturnCount from backend ***** //
export const fetchUnClosedReportSaleReturnCount = async ({ commit }, payload) => {
  try {
    const result = await Axios.get(`report_unclosed_sale_return_count/${payload}`)
    commit('fetchUnClosedReportSaleReturnCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch unPaidReportSaleReturnCount from backend ***** //
export const fetchUnPaidReportSaleReturnCount = async ({ commit }, payload) => {
  try {
    const result = await Axios.get(`report_unpaid_sale_return_count/${payload}`)
    commit('fetchUnPaidReportSaleReturnCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Close SaleReturn from backend ***** //
export const closeSaleReturn = async (ignored, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.get(`sale_return_close/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Closed Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Open SaleReturn from backend ***** //
export const openSaleReturn = async (ignored, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.get(`sale_return_unclose/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Opened Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add SaleReturn  ***** //
export const addSaleReturn = async (ignored, payload = null) => {
  try {
    await Axios.post('sale_return_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Return Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update SaleReturn  info ***** //
export const updateSaleReturnInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`sale_return_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete SaleReturn  ***** //
export const deleteSaleReturn = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`sale_return_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}
